<template>
    <div :id="this.$route.name">
        <Card back>
            <template v-slot:header>
                <h4 class="d-inline">لـیست پرداخت های آنلاین</h4>
                <hr />
            </template>
            <template v-slot:content>
                <BnpGrid v-if="$store.state.renderComponentGrid" :propsColumn="ColumnRiz" :propsRows="rowsRiz" :action="true" :hasRowNum="true">
                    <template slot="Amount" slot-scope="props">
                        {{$Comma3ragham(props.props.Amount)}}
                    </template>
                    <template slot="action-slot" slot-scope="props">
                        <button v-if="props.props.CounterPay!=null"  class="btn btn-lg text-success" @click="CopyCode(props.props)" title="کپی کد"><i class="fad fa-copy"></i></button>
                    </template>
                </BnpGrid>
            </template>
        </Card>
        <b-modal size="xl" centered id="modal-GnerateCode">
            <template #modal-header="{ close }">
                <b-button size="sm" variant="outline-danger" @click="close()">
                    <span aria-hidden="true">&times;</span>
                </b-button>
                <h5>جزئیات </h5>
            </template>

            <template #default>
                <div class="float-left" dir="ltr">
                    <span class="text-info">
                        {{GnerateCode}}
                    </span>
                </div>

            </template>
            <template #modal-footer="{ cancel }">
                <b-button id="CancelCopy" size="sm" variant="danger" @click="cancel()">
                    بستن
                </b-button>

            </template>
        </b-modal>
    </div>
</template>
<script>
import Card from '@/components/Card/Card.vue';
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue';
export default {
    data() {
        return {
            ColumnRiz:[{ name: 'Id', label: 'Id', visibility: false },
                     { name: 'ProductName', label: 'نام محصول', visibility: true },  
                     { name: 'Amount', label: 'مبلغ', visibility: true },
                     { name: 'Date', label: 'تاریخ تراکنش', visibility: true },
                     { name: 'TrackingCode', label: 'شماره پیگیری', visibility: true },],
            rowsRiz:[],
            DataAxios_GetdatRiz: { ArryfildValue: {} },
            DataAxios_GetdataCode: { ArryfildValue: {} },
            GnerateCode:null
        };
    },
    mounted(){
        this.DataAxios_GetdatRiz.Action = 'Deposit/GetOnlinePayment'
        this.DataAxios_GetdatRiz.ArryfildValue.tblCustomerId = this.$session.get('CustomerInfo').Id 
        this.DataAxios_GetdatRiz.Method = 'Post'
        this.DataAxios_GetdatRiz.Token = this.$session.get('Token');
          this.$PostData(this.DataAxios_GetdatRiz).then((data) => {
            this.rowsRiz=data;
            this.$store.state.renderComponentGrid = false;
            this.$nextTick(() => {
                this.$store.state.renderComponentGrid = true
            })
          });
    },
    components: { Card, BnpGrid },
    methods:{
        CopyCode(row){
            this.DataAxios_GetdataCode.Action='Deposit/GetGenrateCode'
            this.DataAxios_GetdataCode.ArryfildValue.tblCustomerId = this.$session.get('CustomerInfo').Id 
            this.DataAxios_GetdataCode.ArryfildValue.Amount=row.Amount 
            this.DataAxios_GetdataCode.ArryfildValue.TrackingCode=row.TrackingCode 
            this.DataAxios_GetdataCode.ArryfildValue.Counter =this.$store.state.counterSharj
            this.DataAxios_GetdataCode.ArryfildValue.CodeTakhfif=row.CodeTakhfif 
            this.DataAxios_GetdataCode.Method = 'Post'
            this.DataAxios_GetdataCode.Token = this.$session.get('Token');
            this.$PostData(this.DataAxios_GetdataCode).then((data) => {
                this.GnerateCode=data
                navigator.clipboard.writeText(this.GnerateCode);
                
            }).finally(() => {
                
                this.$toasted.success('کد شارژ پیامک با موفقیت کپی شد ', {
                    action: {
                        text: 'بستن',
                        onClick: (e, toastObject) => {
                        toastObject.goAway(0)
                        },
                    },
                    })
                this.$store.state.renderComponentGridModal = false;
                this.$nextTick(() => {
                    this.$store.state.renderComponentGridModal = true;
                });
            });
        }
    }
}
</script>
<style scoped>

</style>